import { SocialMediaSharer } from '#components/SocialMediaSharer';

import styles from './ArticleModuleHeroSocialMediaSharer.module.scss';

type Props = {
	shareUrl: string;
	title: string;
	commentId: string | undefined;
};

// Used on desktop. `ArticleModuleSocialMediaSharer` is the one for mobile.
export function ArticleModuleHeroSocialMediaSharer({ shareUrl, title, commentId }: Props) {
	return (
		<div className={`${styles.wrapper}`}>
			<SocialMediaSharer className={styles.sharer} direction="vertical" commentId={commentId} headline={title} url={shareUrl} />
		</div>
	);
}
